module.exports = __webpack_public_path__ + "c1312966ed990a0ece65563cf97becf5.svg";


//////////////////
// WEBPACK FOOTER
// ../images/icons/svg/fa-sort.svg
// module id = 1019
// module chunks = 69